module.exports = __webpack_public_path__ + "static/media/YM57_5.0c982afe.jpg";